import React from "react";
import { Calendar, Clock, MapPin, Users, Sparkles, Award, ArrowRight, Video } from "lucide-react";

const EVENTS = [
  { id: 1, title: "Advances in Endodontic Microsurgery", type: "Workshop", date: "Mar 12, 2026", time: "10:00 AM – 4:00 PM", venue: "Mumbai • Hybrid", speakers: "Dr. R. Sharma, Dr. K. Nair", cpd: 6, seats: "48 seats left", price: 4999, tag: "trending", image: "https://images.pexels.com/photos/3845810/pexels-photo-3845810.jpeg?auto=compress&cs=tinysrgb&w=600" },
  { id: 2, title: "Digital Smile Design Masterclass", type: "Livestream", date: "Mar 18, 2026", time: "6:00 PM – 8:30 PM", venue: "Online", speakers: "Dr. A. Iyer", cpd: 3, seats: "Unlimited", price: 1999, tag: "new", image: "https://images.pexels.com/photos/6812495/pexels-photo-6812495.jpeg?auto=compress&cs=tinysrgb&w=600" },
  { id: 3, title: "Implantology Hands-on Symposium", type: "Conference", date: "Apr 5, 2026", time: "9:00 AM – 6:00 PM", venue: "Bengaluru", speakers: "Panel of 12", cpd: 12, seats: "Only 20 seats", price: 12999, tag: "hot", image: "https://images.pexels.com/photos/3779705/pexels-photo-3779705.jpeg?auto=compress&cs=tinysrgb&w=600" },
  { id: 4, title: "Practice Growth & Digital Marketing for Dentists", type: "Webinar", date: "Apr 10, 2026", time: "7:00 PM – 8:30 PM", venue: "Online", speakers: "Business Panel", cpd: 2, seats: "Unlimited", price: 0, tag: "free", image: "https://images.pexels.com/photos/3985163/pexels-photo-3985163.jpeg?auto=compress&cs=tinysrgb&w=600" },
  { id: 5, title: "Full-Mouth Rehabilitation — Case Documentation", type: "Workshop", date: "Apr 20, 2026", time: "10:00 AM – 5:00 PM", venue: "New Delhi", speakers: "Dr. V. Kapoor", cpd: 8, seats: "15 seats left", price: 7999, tag: null, image: "https://images.pexels.com/photos/6812544/pexels-photo-6812544.jpeg?auto=compress&cs=tinysrgb&w=600" },
  { id: 6, title: "Ortho Aligners — Clinical Case Selection", type: "Livestream", date: "May 2, 2026", time: "6:30 PM – 8:00 PM", venue: "Online", speakers: "Dr. M. Kaur", cpd: 2, seats: "Unlimited", price: 999, tag: null, image: "https://images.pexels.com/photos/6528856/pexels-photo-6528856.jpeg?auto=compress&cs=tinysrgb&w=600" },
];

const TAG_STYLES = {
  trending: "bg-[#FFB020] text-[#111827]",
  new: "bg-emerald-500 text-white",
  hot: "bg-[#F43F5E] text-white",
  free: "bg-[#4B2AAD] text-white",
};

export default function Events() {
  return (
    <main className="pb-16">
      {/* Hero */}
      <section className="dyntra-container mt-6">
        <div className="rounded-3xl overflow-hidden relative" style={{ background: "linear-gradient(135deg, #361D82 0%, #4B2AAD 55%, #6B4CD9 100%)" }}>
          <div className="absolute inset-y-0 right-0 w-1/2 hidden md:block opacity-30">
            <img src="https://customer-assets-cm19k8pv.emergentagent.net/job_dyntra-store-preview/artifacts/11a2lg84_What%20brings%20you%20here7.png" alt="" className="h-full w-full object-cover mix-blend-luminosity" />
          </div>
          <div className="relative px-8 sm:px-14 py-12 md:py-16 max-w-2xl text-white">
            <p className="text-xs font-bold uppercase tracking-[0.24em] text-white/80 mb-3">Dyntra Events</p>
            <h1 data-testid="events-title" className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight">Learn. Network. Grow.</h1>
            <p className="mt-3 text-white/90 text-base max-w-md">Workshops, livestreams and conferences by India's top dental faculty. Earn CDE credits and share cases with peers.</p>
            <div className="flex flex-wrap items-center gap-3 mt-6">
              <a href="#events-list" className="inline-flex items-center gap-2 rounded-xl bg-white text-[#4B2AAD] px-5 py-2.5 text-sm font-bold hover:bg-white/90 shadow-lg">Browse Events <ArrowRight className="h-4 w-4" /></a>
              <a href="#" className="inline-flex items-center gap-2 rounded-xl border border-white/30 bg-white/10 backdrop-blur px-5 py-2.5 text-sm font-bold text-white hover:bg-white/20">
                <Video className="h-4 w-4" /> Watch Past Events
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="dyntra-container mt-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {[
            { icon: Calendar, label: "Live Events", value: "24+" },
            { icon: Users, label: "Attendees", value: "12,000+" },
            { icon: Award, label: "CDE Certified", value: "80%" },
            { icon: Sparkles, label: "Top Faculty", value: "40+" },
          ].map((s) => (
            <div key={s.label} data-testid={`events-stat-${s.label.replace(/\s+/g,"-").toLowerCase()}`} className="dyntra-card p-4 hover:translate-y-0 hover:shadow-none flex items-center gap-3">
              <div className="h-10 w-10 rounded-lg bg-[#F3EFFC] flex items-center justify-center"><s.icon className="h-5 w-5 text-[#4B2AAD]" /></div>
              <div>
                <p className="font-display text-lg font-extrabold text-gray-900">{s.value}</p>
                <p className="text-xs text-gray-500">{s.label}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* List */}
      <section id="events-list" className="dyntra-container mt-14">
        <div className="flex items-end justify-between mb-6">
          <div>
            <h2 className="font-display text-2xl sm:text-3xl font-bold text-gray-900">Upcoming Events</h2>
            <p className="text-sm text-gray-500 mt-1">Hand-picked programs. All faculty-verified.</p>
          </div>
          <div className="hidden md:flex items-center gap-2">
            {["All", "Workshop", "Livestream", "Conference", "Webinar"].map((f, i) => (
              <button key={f} className={`px-3 py-1.5 rounded-full text-xs font-semibold border ${i === 0 ? "bg-[#4B2AAD] text-white border-[#4B2AAD]" : "border-gray-200 text-gray-600 hover:border-[#4B2AAD]/40"}`}>{f}</button>
            ))}
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {EVENTS.map((e) => (
            <article key={e.id} data-testid={`event-card-${e.id}`} className="dyntra-card overflow-hidden flex flex-col">
              <div className="relative aspect-[16/9] bg-gray-100 overflow-hidden">
                <img src={e.image} alt="" className="h-full w-full object-cover" />
                {e.tag && (
                  <span className={`absolute top-2.5 left-2.5 rounded-full px-2.5 py-1 text-[10px] font-bold uppercase ${TAG_STYLES[e.tag]}`}>
                    {e.tag === "free" ? "FREE" : e.tag}
                  </span>
                )}
                <span className="absolute top-2.5 right-2.5 rounded-full bg-white/95 px-2.5 py-1 text-[10px] font-bold text-gray-900">{e.type}</span>
              </div>
              <div className="p-4 flex-1 flex flex-col">
                <h3 className="font-display text-base font-bold text-gray-900 line-clamp-2 min-h-[44px]">{e.title}</h3>
                <div className="mt-2 space-y-1 text-xs text-gray-600">
                  <div className="flex items-center gap-1.5"><Calendar className="h-3.5 w-3.5 text-[#4B2AAD]" /> {e.date}</div>
                  <div className="flex items-center gap-1.5"><Clock className="h-3.5 w-3.5 text-[#4B2AAD]" /> {e.time}</div>
                  <div className="flex items-center gap-1.5"><MapPin className="h-3.5 w-3.5 text-[#4B2AAD]" /> {e.venue}</div>
                  <div className="flex items-center gap-1.5"><Users className="h-3.5 w-3.5 text-[#4B2AAD]" /> {e.speakers}</div>
                </div>
                <div className="mt-3 flex items-center justify-between">
                  <span className="dyntra-chip"><Award className="h-3 w-3" /> {e.cpd} CDE credits</span>
                  <span className="text-[11px] text-gray-500">{e.seats}</span>
                </div>
                <div className="mt-4 flex items-center justify-between border-t border-gray-100 pt-3">
                  <div>
                    {e.price === 0 ? <span className="text-emerald-600 font-bold text-sm">FREE</span> : <>
                      <span className="text-[11px] text-gray-500">from</span>
                      <p className="font-display text-lg font-extrabold text-[#4B2AAD] leading-none">₹{e.price.toLocaleString()}</p>
                    </>}
                  </div>
                  <button data-testid={`event-register-${e.id}`} className="inline-flex items-center gap-1.5 rounded-xl bg-[#4B2AAD] hover:bg-[#361D82] text-white text-sm font-semibold px-4 py-2 transition-colors">Register <ArrowRight className="h-3.5 w-3.5" /></button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>
    </main>
  );
}
